import AccountRecoveryForm from "app/features/authentication/templates/AccountRecoveryForm";

export default function AccountRecoveryScreen() {
  return <AccountRecoveryForm />;
}
